import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_RACKS } from "./actionTypes";
import { getRacksSuccess, getRacksError } from "./actions";

// Include call API
import { getRacksAPI } from "../../../api/racks";

const racksAPI = getRacksAPI();

function* getAllRacks({ payload: { user , size, page, status, carrierType, search} }) {

  try {
    var response = yield call(racksAPI.getRacks, user.token, size, page, status, carrierType, search);
    yield put(getRacksSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getRacksError(error));
  }
}

export function* watchGetRacks() {
  yield takeEvery(GET_RACKS, getAllRacks);
}

function* getRacksSaga() {
  yield all([fork(watchGetRacks)]);
}

export default getRacksSaga;
